<template>
<div class="chapter">
<div class="inner_page">
<div id="dedication">
<p class="noindent">This book is dedicated to</p>
<p class="center">SANDI</p>
<p class="noindent">xxoo</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004dedication.vue?6348b7b1